<template>
    <a href="javascript:void(0)" @click="showChatbox">
        {{ __('ai_chatbox', 'chat_with_our_ai') }}
    </a>
</template>
<script>
export default {
    methods: {
        showChatbox() {
            this.$root.$emit('show-chatbox');
        }
    }
}
</script>
